export default "__VITE_ASSET__D0Jyo1zc__"